import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import './../../index.css';
import '../privacy/Privacy.css';
import Header from '../../sections/header/header';
import Footer from '../../sections/footer/footer';

const termsPage =
    <>
      <Header></Header>
      <div className="content">
        <div className="container">
          
          <div className="row">
            <div className="col-md-12">
              <h1 className='header'>Terms & Conditions</h1>
              <p>Last updated May 01, 2026</p>
              
              <h2 className='titles'>Overview</h2>
              <p>
                Welcome to OnTime ITS. By subscribing to our messaging services, you agree to the following Terms & Conditions. These terms govern your use of our SMS program and outline important information regarding message delivery, charges, and your rights as a user.
              </p>

              <h3 className='titles'>1. Program Description</h3>
              <p>
                By opting into OnTime ITS, users agree to receive SMS messages that may include updates, notifications, promotional content, alerts, or other relevant information related to our services.
              </p>

              <h3 className='titles'>2. SMS Usage Disclosure</h3>
              <p>
                Users may receive SMS messages after voluntarily opting into our messaging program through our website or other subscription methods.                
              </p>

              <h3 className='titles'>3. Message Frequency</h3>
              <p>
                Message frequency may vary depending on user interaction, preferences, and service updates.
              </p>

              <h3 className='titles'>4. Message Charges</h3>
              <p>
                Message and data rates may apply for messages sent to you from us and to us from you. Charges depend on your mobile carrier and service plan. Please contact your wireless provider for details regarding your messaging or data plan.
              </p>

              <h3 className='titles'>5. Opt-Out Instructions</h3>
              <p>
                You can cancel the SMS service at any time. To unsubscribe, simply reply STOP to any message you receive from us. After sending STOP, you will receive a confirmation message, and you will no longer receive SMS communications from us unless you opt in again.
              </p>

              <h3 className='titles'>6. HELP Instructions</h3>
              <p>
                If you are experiencing issues with the messaging program or need assistance, you can reply HELP at any time. You may also contact us directly at: <a href="mailto:support@ontimeits.com">support@ontimeits.com</a>
              </p>

              <h3 className='titles'>7. Consent Clause</h3>
              <p>
                By opting into this SMS program, you acknowledge that your consent to receive messages is not a condition of any purchase. You can choose not to subscribe without affecting your ability to use our services.
              </p>

              <h3 className='titles'>8. Carrier Disclaimer</h3>
              <p>
                Mobile carriers are not liable for delayed or undelivered messages.
              </p>

              <h3 className='titles'>9. Data Usage & Privacy</h3>
              <p>
                Your information will be handled in accordance with our Privacy Policy. SMS data usage and communication practices are aligned with our privacy standards. For more details, please review our Privacy Policy here: <a href="/privacy-policy">Privacy Policy</a>
              </p>

              <h3 className='titles'>10. Changes to Terms</h3>
              <p>
                We reserve the right to update or modify these Terms & Conditions at any time. Any changes will be posted on this page with an updated effective date.
              </p>

              <h3 className='titles'>11. Contact Information</h3>
              <p>
                If you have any questions regarding these Terms & Conditions, please contact us at: <a href="mailto:support@ontimeits.com">support@ontimeits.com</a>
              </p>

              <br></br><br></br>
            </div>  
          </div>
        </div>
       
      </div>
      <Footer></Footer>
    </>


function TermsAndConditions() {
  return (termsPage);
}

export default TermsAndConditions;